module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"listeningMsg":"I am listening...","bubbletextafteraction":"Please face towards the camera, tap on the microphone button, and ask a court-related question."},"es":{"listeningMsg":"Estoy escuchando...","bubbletextafteraction":"Por favor, mire hacia la cámara, toque el botón del micrófono y haga una pregunta relacionada con el tribunal."}}')
  delete Component.options._Ctor
}
